import useFetch from "../../../hooks/useFetch";
import { Link } from "react-router-dom";

export default function ListServices() {
    const { data: services } = useFetch('/services/', 'GET');

  return (
    <ul className="p-10 space-y-6">
          {services ? services.map((service) => (
            <Link to={`/services/coming-soon`} key={service.id}>
              <li
                className="text-center text-white px-10 py-8 border-4 rounded-md border-black m-auto
                hover:scale-105 duration-100 cursor-pointer bg-blue-600 my-5"
              >
                <p className="text-3xl text-bold black-ops-font">{service.name}</p>
                <p className='text-md my-3'>{service.description}</p>
                <p className='text-sm my-3'>${service.price}</p>
              </li>
            </Link>
          )) : (
            <p>My backend server is temporarily shut off. Please come back later.</p>
          )}
      </ul>
  )
}
